import { useQuery } from "@tanstack/react-query";
import { endpoints } from "@/api";
import { useAuth } from "@/auth";

export function useAdmin() {
  const { user } = useAuth();
  const { data } = useQuery({
    queryKey: ["admin", "check"],
    queryFn: endpoints.adminCheck,
    enabled: !!user,
    retry: false,
    staleTime: 60_000,
  });
  return Boolean(user && data?.is_admin);
}
